import { BillingRecurringTypes } from "app/models/ss-api/price.billing.cycle";

export interface IAddProductRequest {

    AdminID: number;
    ProductID: number;
    CreditCardID: number;
    BillingCycle: BillingRecurringTypes;
    AssignToOwner: boolean;
    Initials: string;
    DesignerEmail: string;
    DesignerName: string;
    YardAddon: boolean;
}

export class AddProductRequest implements IAddProductRequest {

    AdminID: number;
    ProductID: number;
    CreditCardID: number;
    BillingCycle: BillingRecurringTypes;
    AssignToOwner: boolean;
    Initials: string;
    DesignerEmail: string;
    DesignerName: string;
    YardAddon: boolean;
}
